import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Img from "gatsby-image"
import { Link, graphql } from "gatsby"
import { FaHeart, FaBookOpen } from "react-icons/fa"

const BlogPage = ({ data }) => {
  return (
    <React.Fragment>
      <SEO title="Wedding Blog" />
      <Layout>
        <div className="container my-5 py-5">
          <h1 className="display-4 text-center">Wedding Blog</h1>
          <p className="lead text-muted text-center">
            Selected Images From Wedding Day Stories
          </p>
        </div>

        <nav className="bg-light border container d-flex justify-content-start align-items-center py-4">
          <ul className="d-flex list-unstyled p-0 m-0">
            <li className="mr-4 ">
              <Link
                activeClassName="font-weight-bold"
                className="text-muted"
                to="/blog"
              >
                <FaHeart className="mr-3" />
                Wedding
              </Link>
            </li>
            <li className="mr-4">
              <Link
                activeClassName="font-weight-bold"
                className="text-muted"
                to="/resources"
              >
                <FaBookOpen className="mr-3" />
                Resources
              </Link>
            </li>
          </ul>
        </nav>
        <div className="py-2" />
        <section className="container">
          <div className="row no-gutter">
            {data.blogImages.edges.map(image => {
              return (
                <div className="col-12 col-md-6 mt-3 no-gutter">
                  <Img
                    style={{ height: "20rem" }}
                    fluid={image.node.childImageSharp.fluid}
                  />
                </div>
              )
            })}
          </div>
        </section>
        <div className="py-5" />
      </Layout>
    </React.Fragment>
  )
}

export default BlogPage

export const query = graphql`
  {
    blogImages: allFile(filter: { relativeDirectory: { eq: "blogPage" } }) {
      edges {
        node {
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`
